import { prefixLocale } from './prefix-locale';

export function buildEnglishIqPath(locale?: string): string {
  return prefixLocale('/english-iq', locale);
}
